var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPittsburghPiratesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.666664 120",
    height: 120,
    width: 86.666664,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,120)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#fdb827",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 600.039,601.289 c 0,45.859 6.441,95.621 35.191,145.082 C 559.34,765.199 500.82,836.719 481.879,900 450.391,869.219 419.531,862.07 370.699,862.07 L 44.4102,862.539 0,751.48 C 26.8398,739.922 44.4102,714.449 44.4102,683.91 V 175.199 C 44.4102,144.648 26.8398,119.219 0,107.66 L 44.4102,0 H 168.98 l 44.461,107.66 c -26.839,11.09 -44.461,37.461 -44.461,67.539 v 200.539 l 201.719,-0.117 c 48.832,0 79.692,-12.031 111.18,-42.769 20.543,63.238 82.34,110.429 158.242,129.257 -28.793,49.45 -40.082,93.36 -40.082,139.18 M 427.852,486.129 H 169.609 v 269.18 h 258.243 c 40.898,0 66.488,-25.778 66.488,-59.957 v -153.75 c 0,-35.864 -20.238,-55.473 -66.488,-55.473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#fdb827",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 223.199,2.80859 V 30.2695 h 10.121 v 6.0196 h -27.031 v -6.0196 h 10.082 V 2.80859 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#fdb827",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 279.059,2.80859 V 36.2891 h -11.758 l -8.082,-21.8789 h -0.199 l -7.77,21.8789 H 239.449 V 2.80859 h 6.84 V 29.4102 h 0.121 l 9.371,-26.60161 h 6.598 l 9.691,26.60161 h 0.16 V 2.80859 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPittsburghPiratesLogo);
export default __webpack_public_path__ + "static/media/pittsburgh-pirates-logo.f1f90d2680225d6df195593176fe1ee9.svg";
export { ForwardRef as ReactComponent };